import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ModelCategoryList from './ModelCategoryList';
import { getModelCategoryManager, getUserProfileWidget, getCurrentTimezone, getUserOrgModelCategoryType } from '../../selectors/index';
import { getModelCategoriesThunk, setModelCategoryCurrentPage, setModelCategoryPageFilter, setFilteredModelCategoryDataThunk, modelCategoryCleanUpThunk } from  '../../actions/modelCategory';

const mapStateToProps = state => {
  return {
    modelCategoryManager: getModelCategoryManager(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    userModelCategories: getUserOrgModelCategoryType(state)

  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getModelCategories: (offset, limit, filter, organisationId) => getModelCategoriesThunk(offset, limit, filter, 'MODELCATEGORY_TAB', organisationId),
      setCurrentPage: currentPage => setModelCategoryCurrentPage(currentPage),
      setPageFilter: filter => setModelCategoryPageFilter(filter),
      setFilterData: filteredData => setFilteredModelCategoryDataThunk(filteredData),
      cleanUp: (initialData) => modelCategoryCleanUpThunk(initialData)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ModelCategoryList);
